import React, { useEffect, useState } from "react";
import { Button, Input, Table, Tooltip, message } from "antd";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { BsSearch, BsX } from "react-icons/bs";
import { BiSolidDownArrow, BiSolidRightArrow } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";

import RouteModal from "../components/modules/route/routeModal";
import ImportModal from "../components/modules/importModal";
import ConfirmationModal from "../components/common/confirmationModal";
import {
  asyncDeleteAllRoute,
  asyncDeleteRoute,
  asyncDeleteSelectedRoute,
  asyncGetRoute,
  asyncImportRoute,
} from "../redux/slices/routeSlice";
import ErrorData from "../components/modules/route/errorData";

const { Column } = Table;

const RoutesPage = () => {
  const dispatch = useDispatch();
  const {
    loading,
    data,
    pagination,
    deleteLoading,
    importLoading,
    deleteAllLoading,
    deleteSelectedLoading,
  } = useSelector((state) => ({
    loading: state.route.getRoute.loading,
    data: state.route.getRoute.data,
    pagination: state.route.getRoute.pagination,
    deleteLoading: state.route.deleteRoute.loading,
    importLoading: state.route.importRoute.loading,
    deleteAllLoading: state.route.deleteAllRoute.loading,
    deleteSelectedLoading: state.route.deleteSelectedRoute.loading,
  }));

  const templateDetails = {
    id: "",
    arriveTime: "",
    departTime: "",
    arriveDate: "",
    departDate: "",
  };

  const initModalData = {
    customer: "",
    puroute: "",
    routeDate: "",
    specMiles: "",
    rteType: "solo",
    relay: "yes",
    frequency: "5",
    period: "",
    periodYear: "",
    pudTime: "",
    suppliersIds: [{ ...templateDetails }],
    plant_id: "",
    plantArrivalTime: "",
    plantArrivalDate: "",
    plantDepartTime: "",
    plantDepartDate: "",
  };

  const [currentColumn, setCurrentColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchText, setSearchText] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [openImportModal, setOpenImportModal] = useState(false);
  const [modalData, setModalData] = useState({
    mode: "",
    data: initModalData,
  });
  const [file, setFile] = useState(null);
  const [openModalError, setOpenModalError] = useState(false);
  const [errorData, setErrorData] = useState([]);
  const [successData, setSuccessData] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isDeleteAll, setIsDeleteAll] = useState(false);
  const [isDeleteSelected, setIsDeleteSelected] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  const [expandedRowKey, setExpandedRowKey] = useState(null);

  const handleExpandRow = (record) => {
    const newRowKey = expandedRowKey === record?.id ? null : record?.id;
    setExpandedRowKey(newRowKey);
  };

  const expandedRowRender = (record) => {
    return (
      <>
        {record && (
          <>
            <table className="expand_up_table">
              <tbody>
                <tr>
                  <td>
                    <strong>Customer</strong>
                  </td>
                  <td className="expand_table_data">{record?.customer}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Route</strong>
                  </td>
                  <td className="expand_table_data">{record?.puroute}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Route Date</strong>
                  </td>
                  <td className="expand_table_data">{record?.routeDate}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Spec Miles</strong>
                  </td>
                  <td className="expand_table_data">{record?.specMiles}</td>
                </tr>
                <tr>
                  <td>
                    <strong>RTE Type</strong>
                  </td>
                  <td className="expand_table_data">{record?.rteType}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Relay</strong>
                  </td>
                  <td className="expand_table_data">{record?.relay}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Frequency</strong>
                  </td>
                  <td className="expand_table_data">{record?.frequency}</td>
                </tr>
                {/* <tr>
                  <td>
                    <strong>Depart Day</strong>
                  </td>
                  <td className="expand_table_data">{record?.departDay}</td>
                </tr> */}
                <tr>
                  <td>
                    <strong>Period</strong>
                  </td>
                  <td className="expand_table_data">{record?.period}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Period Year</strong>
                  </td>
                  <td className="expand_table_data">{record?.periodYear}</td>
                </tr>
                <tr>
                  <td>
                    <strong>PUD Time</strong>
                  </td>
                  <td className="expand_table_data">{record?.pudTime}</td>
                </tr>
              </tbody>
            </table>
            <table className="expand_down_table">
              <thead>
                <tr>
                  <th style={{ width: "20%" }}>Supplier</th>
                  <th style={{ width: "10%" }}>Code</th>
                  <th style={{ width: "15%" }}>Arrival Date</th>
                  <th style={{ width: "15%" }}>Arrival Time</th>
                  <th style={{ width: "15%" }}>Depart Date</th>
                  <th style={{ width: "15%" }}>Depart Time</th>
                  <th>Order</th>
                </tr>
              </thead>
              {record?.suppliersData?.map((supplier, index) => {
                return (
                  <tbody key={supplier?.id}>
                    <tr className="expand_row_table">
                      <td className="expand_row_field">{supplier?.address}</td>
                      <td className="expand_row_field">{supplier?.code}</td>
                      <td className="expand_row_field">
                        {supplier?.arriveDate}
                      </td>
                      <td className="expand_row_field">
                        {supplier?.arriveTime}
                      </td>
                      <td className="expand_row_field">
                        {supplier?.departDate}
                      </td>
                      <td className="expand_row_field">
                        {supplier?.departTime}
                      </td>

                      <td className="expand_row_field">{index + 1}</td>
                    </tr>
                  </tbody>
                );
              })}
            </table>

            <table className="expand_down_table" style={{ marginTop: "1rem" }}>
              <thead>
                <tr>
                  <th style={{ width: "20%" }}>Plant Name</th>
                  <th style={{ width: "10%" }}>Code</th>
                  <th style={{ width: "15%" }}>Arrival Date</th>
                  <th style={{ width: "15%" }}>Arrival Time</th>
                  <th style={{ width: "15%" }}>Depart Date</th>
                  <th style={{ width: "15%" }}>Depart Time</th>
                  <th style={{ border: "none" }} />
                </tr>
              </thead>
              <tbody>
                <tr className="expand_row_table ">
                  <td className="expand_row_field">
                    {record?.plantData?.plantName}
                  </td>
                  <td className="expand_row_field">
                    {record?.plantData?.code}
                  </td>
                  <td className="expand_row_field">
                    {record?.plantArrivalDate}
                  </td>
                  <td className="expand_row_field">
                    {record?.plantArrivalTime}
                  </td>
                  <td className="expand_row_field">
                    {record?.plantDepartDate}
                  </td>
                  <td className="expand_row_field">
                    {record?.plantDepartTime}
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        )}
      </>
    );
  };

  const header = () => {
    return (
      <div>
        <div className="table_header">
          <div className="button_margin">
            <Input
              placeholder={"Search Route"}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="search_input"
              prefix={<BsSearch />}
              suffix={
                searchText && (
                  <BsX
                    style={{ cursor: "pointer" }}
                    onClick={() => setSearchText("")}
                  />
                )
              }
            />
          </div>
          <div className="table_header_button">
            <Button
              className="button_margin"
              onClick={() => {
                setOpenImportModal(true);
              }}
            >
              Import
            </Button>
            <Button
              className="button_margin"
              onClick={() => {
                const filePath = "/sampleSheet/sample_routes.csv";
                window.open(filePath, "_blank");
              }}
            >
              Download Import Template
            </Button>
            <Button
              onClick={() => {
                setOpenModal(true);
                setModalData({
                  mode: "add",
                  data: initModalData,
                });
              }}
            >
              Create New
            </Button>
          </div>
        </div>
        <div className="table_header_down">
          {pagination?.totalItems > 0 && (
            <Button
              className="button_margin"
              onClick={() => {
                setIsDeleteAll(true);
              }}
            >
              {`Delete all available data`}
            </Button>
          )}
          {selectedIds.length > 0 && (
            <Button
              className="button_margin"
              onClick={() => {
                setIsDeleteSelected(true);
              }}
            >
              {`Delete selected (${selectedIds.length}) data`}
            </Button>
          )}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (!isInitialRender) {
      const delay = 500;
      const timeoutId = setTimeout(() => {
        dispatch(
          asyncGetRoute({
            page: 1,
            limit: 10,
            q: searchText,
          })
        );
      }, delay);
      return () => clearTimeout(timeoutId);
    } else {
      setIsInitialRender(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const handleSubmit = () => {
    
    setOpenModalError(false);
    setErrorData([]);
    setSuccessData([]);
    if (file) {
      const formData = new FormData();
      formData.append("upload", file);
      formData.append("isChecked", isChecked || false);
    setOpenImportModal(false);
    // Fire the API call (don't wait for response)
    messageApi.open({
      type: "success",
      content: "The process has started in the background. You will receive email updates.",
    });
    dispatch(asyncImportRoute(formData));

    // Immediately show the background processing message
  

    // Reset form state
    setFile(null);
    setIsChecked(false);
    dispatch(
            asyncGetRoute({
              page: 1,
              limit: 10,
            })
          );
  } else {
    messageApi.open({
      type: "error",
      content: "Please select file",
    });
    setIsChecked(false);
  }
};

  const handleDelete = () => {
    if (deleteId) {
      dispatch(asyncDeleteRoute(deleteId)).then((res) => {
        setConfirmation(false);
        if (res.payload?.status === 200) {
          messageApi.open({
            type: "success",
            content: res.payload?.data?.message,
          });
          dispatch(
            asyncGetRoute({
              page: pagination.page || 1,
              limit: pagination.pageSize || 10,
              q: searchText,
            })
          );
          setDeleteId(0);
        } else {
          setConfirmation(false);
          messageApi.open({
            type: "error",
            content: res.payload?.message,
          });
        }
      });
    }
  };

  const handleDeleteAll = () => {
    dispatch(asyncDeleteAllRoute()).then((res) => {
      setIsDeleteAll(false);
      if (res.payload?.status === 200) {
        messageApi.open({
          type: "success",
          content: res.payload?.data?.message,
        });
        dispatch(
          asyncGetRoute({
            page: pagination.page || 1,
            limit: pagination.pageSize || 10,
            q: searchText,
          })
        );
      } else {
        setIsDeleteAll(false);
        messageApi.open({
          type: "error",
          content: res.payload?.message,
        });
      }
    });
  };

  const handleDeleteSelected = () => {
    dispatch(asyncDeleteSelectedRoute({ ids: selectedIds ?? [] })).then(
      (res) => {
        setIsDeleteSelected(false);
        if (res.payload?.status === 200) {
          messageApi.open({
            type: "success",
            content: res.payload?.data?.message,
          });
          setSelectedIds([]);
          dispatch(
            asyncGetRoute({
              page: pagination.page || 1,
              limit: pagination.pageSize || 10,
              q: searchText,
            })
          );
        } else {
          setIsDeleteSelected(false);
          messageApi.open({
            type: "error",
            content: res.payload?.message,
          });
        }
      }
    );
  };

  const fetchData = (page, pageSize, sortOrder, column) => {
    dispatch(
      asyncGetRoute({
        page,
        limit: pageSize,
        sortOrder: sortOrder,
        sortByColumn: column,
        q: searchText,
      })
    );
  };

  const handleSort = (column) => {
    let newSortOrder;

    if (column !== currentColumn) {
      newSortOrder = "ASC";
    } else {
      if (sortOrder === "ASC") {
        newSortOrder = "DESC";
      } else if (sortOrder === "DESC") {
        newSortOrder = "";
      } else {
        newSortOrder = "ASC";
      }
    }

    setSortOrder(newSortOrder);
    setCurrentColumn(column);
    fetchData(1, 10, newSortOrder, column);
  };

  const onPageChange = (page, pageSize) => {
    fetchData(page, pageSize, sortOrder, currentColumn);
  };

  useEffect(() => {
    dispatch(
      asyncGetRoute({
        page: pagination.page,
        limit: pagination.pageSize,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedIds(selectedRowKeys);
    },
  };

  return (
    <>
      {contextHolder}
      <div className="fixed_header">
        <div className="table_name">Routes</div>
        <div>{header()}</div>
      </div>
      <div
        style={{
          overflowX: "auto",
          maxWidth: "100%",
          //  marginTop: "98px"
        }}
      >
        <Table
          rowKey={(record) => record?.id}
          rowSelection={Object.assign({ type: "checkbox" }, rowSelection)}
          dataSource={data}
          bordered
          size="small"
          loading={loading}
          pagination={{
            current: pagination.page,
            pageSize: pagination.pageSize,
            total: pagination?.totalItems,
            onChange: (page, pageSize) => {
              onPageChange(page, pageSize);
            },
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          expandable={{
            expandedRowRender,
            expandedRowKeys: expandedRowKey ? [expandedRowKey] : [],
            onExpand: (_, record) => handleExpandRow(record),
            expandIcon: ({ expanded, onExpand, record }) =>
              expanded ? (
                <BiSolidDownArrow
                  size={20}
                  className="view_icon expanded"
                  onClick={(e) => onExpand(record, e)}
                />
              ) : (
                <BiSolidRightArrow
                  size={20}
                  className="view_icon"
                  onClick={(e) => onExpand(record, e)}
                />
              ),
          }}
        >
          <Column
            title="Customer"
            key="customer"
            render={(record) => record?.customer}
            sorter={true}
            onHeaderCell={() => ({
              onClick: () => handleSort("customer"),
            })}
          />
          <Column
            title="Puroute"
            key="puroute"
            render={(record) => record?.puroute}
            sorter={true}
            onHeaderCell={() => ({
              onClick: () => handleSort("puroute"),
            })}
          />
          <Column
            title="Route Date"
            key="routeDate"
            render={(record) => record?.routeDate}
            sorter={true}
            onHeaderCell={() => ({
              onClick: () => handleSort("routeDate"),
            })}
          />

          <Column
            title="Spec Miles"
            key="specMiles"
            render={(record) => record?.specMiles}
            sorter={true}
            onHeaderCell={() => ({
              onClick: () => handleSort("specMiles"),
            })}
          />

          <Column
            title="Action"
            key="action"
            width="8%"
            align="center"
            render={(rowData) => (
              <div className="table_icon">
                <>
                  {/* <Tooltip title="View">
                    <i
                      onClick={() => {
                        setOpenModal(true);
                        setModalData({
                          mode: "view",
                          data: rowData,
                        });
                      }}
                    >
                      <BiSolidDownArrow size={20} className="edit_icon" />
                    </i>
                  </Tooltip> */}
                  <Tooltip title="Edit">
                    <i
                      onClick={() => {
                        setOpenModal(true);
                        setModalData({
                          mode: "edit",
                          data: rowData,
                        });
                      }}
                    >
                      <AiFillEdit size={20} className="edit_icon" />
                    </i>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <i
                      onClick={() => {
                        setConfirmation(true);
                        setDeleteId(rowData?.id);
                      }}
                    >
                      <AiFillDelete size={20} className="delete_icon" />
                    </i>
                  </Tooltip>
                </>
              </div>
            )}
          />
        </Table>
        {openModal && (
          <RouteModal
            openModal={openModal}
            setOpenModal={setOpenModal}
            messageApi={messageApi}
            modalData={modalData}
          />
        )}
        {openImportModal && (
          <ImportModal
            openModal={openImportModal}
            setOpenModal={setOpenImportModal}
            setFile={setFile}
            handleSubmit={handleSubmit}
            loading={importLoading}
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            isCheckboxShow={true}
          />
        )}
        {confirmation && (
          <ConfirmationModal
            title={"Delete Route"}
            open={confirmation}
            setOpen={setConfirmation}
            onYes={handleDelete}
            loading={deleteLoading}
          />
        )}
        {isDeleteAll && (
          <ConfirmationModal
            title={"Delete Route"}
            message={"Are you sure you want to delete all available routes?"}
            open={isDeleteAll}
            setOpen={setIsDeleteAll}
            onYes={handleDeleteAll}
            loading={deleteAllLoading}
          />
        )}
        {isDeleteSelected && (
          <ConfirmationModal
            title={"Delete Route"}
            message={"Are you sure you want to delete selected routes?"}
            open={isDeleteSelected}
            setOpen={setIsDeleteSelected}
            onYes={handleDeleteSelected}
            loading={deleteSelectedLoading}
          />
        )}
        {openModalError && (
          <ErrorData
            openModal={openModalError}
            setOpenModal={setOpenModalError}
            errorData={errorData}
            successData={successData}
          />
        )}
      </div>
    </>
  );
};

export default RoutesPage;
